/** @jsxImportSource ../../i18n */
import React from 'react';
import { CartesianGrid, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { usePrefersReducedMotion } from '../../theme/motion';
import { formatDate, formatPercent } from '../../theme/format';
import { ChartTooltip } from './ChartTooltip';
import { axisProps, chartColors, cursorProps, gridProps } from './chartTheme';

// Cumulative return in gold, plus optional comparison lines (dashed) such as
// benchmarks: lines = [{ key, label, color }].
export const ReturnLineChart = ({ data, height = 300, dataKey = 'return', label = 'Portefeuille', lines = [], color = chartColors.goldSoft, className }) => {
  const reduced = usePrefersReducedMotion();
  const labels = Object.fromEntries([[dataKey, label], ...lines.map((l) => [l.key, l.label])]);
  return (
    <div className={className} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 4, bottom: 0, left: 0 }}>
          <CartesianGrid {...gridProps} />
          <XAxis dataKey="date" {...axisProps} minTickGap={36} tickMargin={10} tickFormatter={(d) => formatDate(d, 'dayMonth')} />
          <YAxis {...axisProps} orientation="right" width={56} tickMargin={6} tickFormatter={(v) => formatPercent(v, { decimals: 1 })} />
          <ReferenceLine y={0} stroke={chartColors.border} />
          <Tooltip
            cursor={cursorProps}
            itemSorter={(item) => (item.dataKey === dataKey ? -1 : 0)}
            content={(
              <ChartTooltip
                labelFormatter={(d) => formatDate(d, 'long')}
                nameFormatter={lines.length ? (name) => labels[name] || name : undefined}
                valueFormatter={(v) => formatPercent(v, { decimals: 2 })}
              />
            )}
          />
          {lines.map((line) => (
            <Line
              key={line.key}
              type="monotone"
              dataKey={line.key}
              name={line.key}
              stroke={line.color}
              strokeWidth={1.25}
              strokeDasharray="4 4"
              dot={false}
              connectNulls
              activeDot={{ r: 3, fill: line.color, stroke: chartColors.canvas, strokeWidth: 2 }}
              isAnimationActive={!reduced}
              animationDuration={700}
            />
          ))}
          <Line
            type="monotone"
            dataKey={dataKey}
            name={dataKey}
            stroke={color}
            strokeWidth={1.75}
            dot={false}
            activeDot={{ r: 4, fill: color, stroke: chartColors.canvas, strokeWidth: 2 }}
            isAnimationActive={!reduced}
            animationDuration={700}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
